import { getGuestId } from "@/lib/guest";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/** POSTs to an SSE endpoint and calls back per event. Throws an axios-shaped error on HTTP failure. */
export const streamRequest = async (path, body, { onChecks, onStage, onPartial, onDone, onError }) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 120000);
  const isForm = typeof FormData !== "undefined" && body instanceof FormData;

  const res = await fetch(`${BACKEND_URL}/api${path}`, {
    method: "POST",
    credentials: "include",
    signal: controller.signal,
    headers: isForm ? { "X-Guest-Id": getGuestId() } : { "Content-Type": "application/json", "X-Guest-Id": getGuestId() },
    body: isForm ? body : JSON.stringify(body),
  }).catch((e) => { clearTimeout(timer); throw e; });

  if (!res.ok) {
    let detail = null;
    try { detail = (await res.json())?.detail; } catch { /* non-json error body */ }
    clearTimeout(timer);
    throw Object.assign(new Error(detail || `HTTP ${res.status}`), { response: { status: res.status, data: { detail } } });
  }

  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  const dispatch = (block) => {
    const lines = block.split("\n");
    const evLine = lines.find((l) => l.startsWith("event:"));
    const dataLine = lines.find((l) => l.startsWith("data:"));
    if (!evLine || !dataLine) return;
    const event = evLine.slice(6).trim();
    let data;
    try { data = JSON.parse(dataLine.slice(5).trim()); } catch { return; }
    if (event === "checks") onChecks?.(data);
    else if (event === "stage") onStage?.(data);
    else if (event === "partial") onPartial?.(data);
    else if (event === "done") onDone?.(data);
    else if (event === "error") onError?.(data);
  };

  try {
    for (;;) {
      const { value, done } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      let idx;
      while ((idx = buffer.indexOf("\n\n")) !== -1) {
        dispatch(buffer.slice(0, idx));
        buffer = buffer.slice(idx + 2);
      }
    }
  } finally {
    clearTimeout(timer);
  }
  if (buffer.trim()) dispatch(buffer);
};

export const streamAnalyze = (payload, handlers) => streamRequest("/analyze/stream", payload, handlers);
export const streamSuggest = (payload, handlers) => streamRequest("/suggest/stream", payload, handlers);
export const streamInvoice = (formData, handlers) => streamRequest("/suggest/invoice/stream", formData, handlers);
